import React, { useState } from 'react'
import { Container, Box, Typography, Button } from '@mui/material'
import heroimg from "../assets/hero.png"
import LockIcon from '@mui/icons-material/Lock';
import DraftsIcon from '@mui/icons-material/Drafts';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import { Link } from 'react-router-dom';
import logoimg from "../assets/logo.png"
import axios from "axios"
import { API_BASE_URL } from '../components/Config';
import { useSnackbar } from "notistack";
import isPasswordValid from '../components/CheckPassword';
import { useNavigate } from 'react-router-dom';

const Register = () => {




    const { enqueueSnackbar } = useSnackbar();
    const [showpss, setShowpss] = useState(false)
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [confPassword, setConfPassword] = useState("")
    const navigate = useNavigate()




  const handelAPIFunc = async()=>{
    if (!validateEmail(email)) {
        enqueueSnackbar("Please enter a valid email address", { variant: "error" });
        return;
      }
      const Validpwd = isPasswordValid(password)
      if(Validpwd?.valid) {
          if(password !== confPassword)
          {
            enqueueSnackbar("Password not same!!!",{variant:'error'});
            return
          }
          try {
              const data ={
                  email:email,
                  password:password,
                  confirm_password:confPassword
              }
            const  res = await axios.post(`${API_BASE_URL}/accounts/user/`,data)
            setEmail("")
            setPassword("")
            setConfPassword("")
            if(res?.data?.email){
                enqueueSnackbar("User has ben Created", { variant: "success" });
                navigate("/Login")
            }
            console.log(res)
          } catch (error) {
              console.log(error)
          }
      }else{
        enqueueSnackbar(Validpwd?.message, { variant: "error" });

      }
  }
 
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  }

    return (
        <>
            <div className='back_Login'>
                <Container maxWidth="xl" className='login_container'>
                    <Box className='Login_image'>
                        <img src={heroimg} alt="images" />
                    </Box>
                    <Box className="form_Login">
                        <img src={logoimg} alt="" className='logo_login' />
                        <Box>
                            <Typography variant="h3">Register Yourself</Typography>
                            <p className='login_p'>Please Provide your email and password to  <br /> login into your account!</p>
                        </Box>
                        <Box className="inputs_div">
                            <Box className="input_filde_divs"><input type="email" placeholder='Type email' onChange={(e)=>setEmail(e.target.value)} /> 
                            <Box className="Login_icon"><DraftsIcon sx={{ paddingRight: "2px" }} /></Box></Box>
                            <Box className="input_filde_divs">
                                <input type={`${showpss === true ? 'text' : 'password'}`} placeholder='Type password'onChange={(e)=>setPassword(e.target.value)} />
                                <Box onClick={()=>setShowpss(!showpss)} className="Login_icon">
                                    {showpss === true ? <LockOpenTwoToneIcon /> : < LockIcon />}
                                </Box>
                            </Box>
                            <Box className="input_inner_div">
                                <Box className="input_filde_divs">
                                    <input type={`${showpss === true ? 'text' : 'password'}`} placeholder='Confirm password' onChange={(e)=>setConfPassword(e.target.value)}/>
                                    <Box onClick={()=>setShowpss(!showpss)} className="Login_icon">
                                        {showpss === true ? <LockOpenTwoToneIcon /> : < LockIcon />}
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                        <Box>
                            <Button variant="contained" className='Login_btn mt-3 mb-3' onClick={handelAPIFunc}>
                                Sign Up
                            </Button>
                            <p className='mt-3'>Already have an account? <strong><Link to="/Login">Sign in</Link></strong></p>
                        </Box>

                    </Box>
                </Container>
            </div>
        </>
    )
}

export default Register
